export const SET_BOOKED_DININGS = 'SET_BOOKED_DININGS';
export const SET_BOOKED_ENTERTAINMENTS = 'SET_BOOKED_ENTERTAINMENTS';
export const SET_AVAILABLE_ENTERTAINMENTS = 'SET_AVAILABLE_ENTERTAINMENTS';
